"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.slice(0, 5).map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative inline-flex h-9 items-center justify-center px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:!bg-transparent focus:!bg-transparent outline-none">
                  {item.label}
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-t shadow-medium md:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.slice(0, 5).map(item => <li key={item.id}>
                  <Link to={item.href || "#"} className="block px-4 py-2 text-sm font-medium text-foreground hover:bg-muted-light rounded-md transition-all duration-[var(--duration-fast)] hover:!bg-muted-light focus:!bg-muted-light" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background border-b transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 shadow-soft" : "h-22"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        {}
        <div className="flex items-center gap-3 flex-shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_poswfy5f.jpg" alt="Header photo" className={`object-cover rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-10 w-16" : "h-14 w-20"}`} />
          <Link to="/#">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/the_mass_logo.png" alt="The Mass Logo" className="h-7" />
          </Link>
        </div>

        {}
        <MenuProvider menu_id="19" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden md:inline-flex transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-103 hover:!bg-primary-hover hover:shadow-medium focus:!bg-primary-hover">
          <Link to="/#">Get Tickets</Link>
        </Button>
      </div>
    </header>;
}